export const environment = {
  production: false,

  // apiUrl: "http://10.0.1.153:8081/CosSolser/",
  // socketURL: "http://10.0.1.153:8081/CosSolser/csws",

  //apiUrl: "http://localhost:8081/CosSolser/",
  //socketURL: "http://localhost:8081/CosSolser/csws",

 // apiUrl: "https://10.0.1.53:8085/CosSolser/",
  //socketURL: "https://10.0.1.53:8085/CosSolser/csws",

  apiUrl: '',
  socketURL: 'csws/',

  // apiUrl: 'http://10.0.1.153:8081/',
  // socketURL: 'http://10.0.1.153:8081/csws/',
  // apiUrl: 'https://cosv2.solser-it.com/',
  // socketURL: 'https://cosv2.solser-it.com/csws/',
  //6LcwhcYsAAAAAAjqKlx42c-PO100ulQEWKHku71G,
  // apiUrl: '',
  // socketURL: 'csws/',
  recaptchaSiteKey: '6LcwhcYsAAAAACMWajJDLhULDNUWcJIb_7WK09wK',
};
